import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/**
 * Reusable form fields for assigning a vehicle + driver + phone to a movilizacion.
 * Used by admin approval flow and coordinador assignment flow.
 */
export const FleetSelectFields = ({
  formData,
  setFormData,
  vehiculosOpts,
  conductoresOpts,
  onVehiculoSelect,
  onConductorSelect,
  telefonoRequired = false,
  testIdPrefix = '',
  telefonoTestId = null,
}) => {
  const vId = (suffix) => (testIdPrefix ? `${testIdPrefix}-${suffix}` : suffix);
  const telId = telefonoTestId || vId('telefono-conductor-input');
  return (
    <>
      <div className="space-y-2">
        <Label className="font-['IBM_Plex_Sans'] font-medium text-[#0A0A0A]">
          Vehículo Asignado *
        </Label>
        <Select
          value={formData.vehiculo_id || '__custom__'}
          onValueChange={onVehiculoSelect}
        >
          <SelectTrigger data-testid={vId('vehiculo-select')} className="border-[#E9ECEF] focus:border-[#C1121F] font-['IBM_Plex_Sans']">
            <SelectValue placeholder="Elige un vehículo del catálogo" />
          </SelectTrigger>
          <SelectContent>
            {vehiculosOpts.map((v) => (
              <SelectItem key={v.id} value={v.id} disabled={v.ocupado}>
                {v.alias ? `${v.alias} · ` : ''}{v.patente}
                {v.marca_modelo ? ` · ${v.marca_modelo}` : ''}
                {v.ocupado ? '  (Ocupado)' : ''}
              </SelectItem>
            ))}
            <SelectItem value="__custom__">— Escribir manualmente —</SelectItem>
          </SelectContent>
        </Select>
        <Input
          data-testid={vId('vehiculo-input')}
          value={formData.vehiculo}
          onChange={(e) => setFormData({ ...formData, vehiculo: e.target.value, vehiculo_id: '' })}
          placeholder="Ej: Vehículo #1 - ABC123"
          className="border-[#E9ECEF] focus:border-[#C1121F] font-['IBM_Plex_Sans']"
          required
        />
      </div>

      <div className="space-y-2">
        <Label className="font-['IBM_Plex_Sans'] font-medium text-[#0A0A0A]">
          Conductor Asignado *
        </Label>
        <Select
          value={formData.conductor_id || '__custom__'}
          onValueChange={onConductorSelect}
        >
          <SelectTrigger data-testid={vId('conductor-select')} className="border-[#E9ECEF] focus:border-[#C1121F] font-['IBM_Plex_Sans']">
            <SelectValue placeholder="Elige un conductor del catálogo" />
          </SelectTrigger>
          <SelectContent>
            {conductoresOpts.map((c) => (
              <SelectItem key={c.id} value={c.id} disabled={c.ocupado}>
                {c.nombre_completo} · {c.telefono}
                {c.ocupado ? '  (Ocupado)' : ''}
              </SelectItem>
            ))}
            <SelectItem value="__custom__">— Escribir manualmente —</SelectItem>
          </SelectContent>
        </Select>
        <Input
          data-testid={vId('conductor-input')}
          value={formData.conductor}
          onChange={(e) => setFormData({ ...formData, conductor: e.target.value, conductor_id: '' })}
          placeholder="Nombre del conductor"
          className="border-[#E9ECEF] focus:border-[#C1121F] font-['IBM_Plex_Sans']"
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor={vId('telefono-conductor')} className="font-['IBM_Plex_Sans'] font-medium text-[#0A0A0A]">
          Teléfono del Conductor{telefonoRequired ? ' *' : ''}
        </Label>
        <Input
          id={vId('telefono-conductor')}
          data-testid={telId}
          type="tel"
          value={formData.telefono_conductor}
          onChange={(e) => setFormData({ ...formData, telefono_conductor: e.target.value })}
          placeholder="+593987654321"
          className="border-[#E9ECEF] focus:border-[#C1121F] font-['IBM_Plex_Sans']"
          required={telefonoRequired}
        />
      </div>
    </>
  );
};
